<template>
  <span class="svg-icon-more">
    <svg class="icon-color-1" :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.0541 16.05V11.55" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M14.25 13.8H9.75" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M21 11.1V16.5C21 20.1 20.1 21 16.5 21H7.5C3.9 21 3 20.1 3 16.5V7.5C3 3.9 3.9 3 7.5 3H8.85C10.2 3 10.497 3.396 11.01 4.08L12.36 5.88C12.702 6.33 12.9 6.6 13.8 6.6H16.5C20.1 6.6 21 7.5 21 11.1Z" :stroke="color" stroke-width="1.5" stroke-miterlimit="10"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
  }
}
</script>